import { render, staticRenderFns } from "./error_h5.vue?vue&type=template&id=634c07c1"
import script from "./error_h5.vue?vue&type=script&lang=js"
export * from "./error_h5.vue?vue&type=script&lang=js"
import style0 from "./error_h5.vue?vue&type=style&index=0&id=634c07c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports